import { render, staticRenderFns } from "./MultipleUploadImageByUrls.vue?vue&type=template&id=160ced19&scoped=true&"
import script from "./MultipleUploadImageByUrls.vue?vue&type=script&lang=ts&"
export * from "./MultipleUploadImageByUrls.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160ced19",
  null
  
)

export default component.exports